import React from "react";
import MapContainer from "../components/OnlineStats/MapContainer";
import ChartDimensionContainer from "../components/OnlineStats/ChartDimensionContainer";
import ChartVehiclesContainer from "../components/OnlineStats/ChartVehiclesContainer";
import OverviewContextProvider from "../contexts/OverviewContext";
import CreativeContainer from "../components/OnlineStats/CreativeContainer";
import useAuth from "../hooks/authenticate/useAuth";
import useConfig from "../hooks/useConfig";
import EilatContainer from "../components/OnlineStats/EilatContainer";
import AtidimContainer from "../components/OnlineStats/AtidimContainer";
import TLVmuniContainer from "../components/OnlineStats/TLVmuniContainer";
import YsbContainer from "../components/OnlineStats/YsbContainer";
import AtarimContainer from "../components/OnlineStats/AtarimContainer";
import NationalParkContainer from "../components/OnlineStats/NationalParkContainer";

function OnlineStats() {
  const { auth } = useAuth();
  const { config } = useConfig();

  return (
    <div className="relative px-2 pt-4 -mt-5 w-full h-full flex flex-col justify-center items-center z-10 ">
      <OverviewContextProvider>
        {config["pages"]["statistics"]["components"][
          "chartVehicleContainer"
        ] && (
          <div className="w-full h-1/2 rounded-md">
            <ChartVehiclesContainer token={auth.token} />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["mapContainer"] && (
          <div className="w-full h-4/5 rounded-md">
            <MapContainer token={auth.token} />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["chartInOutContainer"] && (
          <div className="w-full h-full rounded-md">
            <TLVmuniContainer />
          </div>
        )}
        {config["pages"]["statistics"]["components"][
          "chartDimensionContainer"
        ] && (
          <div className="w-full h-full rounded-md">
            <ChartDimensionContainer token={auth.token} />
          </div>
        )}
        {config["pages"]["statistics"]["components"][
          "chartCreativeContainer"
        ] && (
          <div className="w-full h-full rounded-md ">
            <CreativeContainer token={auth.token} />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["eilatContainer"] && (
          <div className="w-full h-full  flex justify-center rounded-md">
            <EilatContainer />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["atidimContainer"] && (
          <div className="w-full h-full  flex justify-center rounded-md">
            <AtidimContainer />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["ysbContainer"] && (
          <div className="w-full h-full  flex justify-center rounded-md">
            <YsbContainer />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["atarimContainer"] && (
          <div className="w-full h-full  flex justify-center rounded-md">
            <AtarimContainer />
          </div>
        )}
        {config["pages"]["statistics"]["components"]["nationalParkContainer"] && (
          <div className="w-full h-full  flex justify-center rounded-md">
            <NationalParkContainer />
          </div>
        )}
      </OverviewContextProvider>
    </div>
  );
}
export default OnlineStats;
